<template>
  <BaseDialog
    :isOpen="true"
    :width="1200"
    :fullscreen="isMobile"
    @close="close"
  >
    <template v-slot:title>
      Add Qualification
    </template>
    <template v-slot:body>
      <QualificationDetailsForm
        :class="{ container: isMobile }"
        ref="qualificationDetailsForm"
      />
    </template>
    <template v-slot:actions>
      <PrimaryButton
        @click.native="close"
        text
        :disabled="isLoading"
        v-if="!isMobile"
      >
        Cancel
      </PrimaryButton>
      <PrimaryButton @click.native="onSubmit" :loading="isLoading">
        Save Changes
      </PrimaryButton>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import QualificationDetailsForm from "@/views/profile/QuestionsAndAnswers/steps/Qualifications/components/QualificationDetailsForm";
import { createNamespacedHelpers } from "vuex";
import { QUALIFICATIONS_NAMESPACE } from "@/store/modules/users/qualifications";
import { ADD_USER_QUALIFICATION } from "@/store/modules/users/qualifications/actions";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { BASE_DATE_FORMAT, API_DATE_FORMAT } from "@/constants/common";
import { formatDate } from "@/utils/time";

const { mapActions } = createNamespacedHelpers(QUALIFICATIONS_NAMESPACE);
const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  name: "AddQualificationDialog",
  components: {
    PrimaryButton,
    BaseDialog,
    QualificationDetailsForm
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    ...mapAuthState({
      self: state => state.userData
    })
  },
  methods: {
    ...mapActions({
      addUserQualification: ADD_USER_QUALIFICATION
    }),
    close() {
      this.$emit("close");
    },
    async onSubmit() {
      const isValid = await this.$refs.qualificationDetailsForm.validate();
      if (isValid) {
        const newQualificationData = this.$refs.qualificationDetailsForm.getData();
        this.isLoading = true;
        await this.addUserQualification({
          ...newQualificationData,
          dateStarted: formatDate({
            date: newQualificationData.dateStarted,
            startFormat: BASE_DATE_FORMAT,
            endFormat: API_DATE_FORMAT
          }),
          dateCompleted: formatDate({
            date: newQualificationData.dateCompleted,
            startFormat: BASE_DATE_FORMAT,
            endFormat: API_DATE_FORMAT
          }),
          user: {
            id: this.self.id,
            type: "users"
          }
        });
        this.close();
        this.$refs.qualificationDetailsForm.clearForm();
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss"></style>
